import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import '@babel/polyfill';
const jwt = require('jsonwebtoken');

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if(!store.getters.loggedIn) {
      next({ path: '/login' });
    }
    else {
      const userToken = store.getters.getUserToken;
      const decodedToken = jwt.decode(userToken);
      const role = decodedToken.data.role;

      const toAdmin = to.path.includes('/admin');

      if(toAdmin && role !== 'admin') next({ path: '/account' });
      next();
    }
  }
  else next();
});


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
